// SidebarItems.js
import IconHome from "../images/home.png";
import IconUser from "../images/user.png";
import IconFounisseur from "../images/IconFournisseur.png";
import IconCommand from "../images/fi_truck.png";
import IconDelivery from "../images/fi_package.png";
import IconPromoCode from "../images/fi_percent.png";
import IconInfo from "../images/info_outline_24px.png";
import IconFacturation from "../images/fi_calendar.png";
import IconSecurity from "../images/fi_alert-circle.png";
import IconLivreur from "../images/fi_truck.png";

const SidebarItems = [
  {
    name: "Dashboard",
    route: "/dashboard",
    icon: IconHome,
  },
  {
    name: "Commandes",
    route: "#",
    icon: IconCommand,
    subcategories: [
      {
        name: "Livraison",
        route: "/livraison",
      },
      {
        name: "E-commerce",
        route: "/orders",
      },
      {
        name: "Heatmap",
        route: "/commandes/heatmap",
      }
    ],
  },
  {
    name: "KPI",
    route: "/",
    icon: IconInfo,
    subcategories: [
      {
        name: "Livraison",
        route: "/livreurs-shifts",
      },
      {
        name: "E-commerce",
        route: "/kpi",
      },
      {
        name: "NPS",
        route: "/nps",
      },
    ],
  },
  {
    name: "Fournisseurs",
    route: "/",
    icon: IconFounisseur,
    subcategories: [
      { name: "Liste", route: "/fournisseurs" },
      { name: "Partenaires API", route: "/partenaires" },
      { name: "Appels API", route: "/partenaires/appels" },
    ],
  },
  {
    name: "Facturation",
    route: "/",
    icon: IconFacturation,
    subcategories: [
      {
        name: "À facturer",
        route: "/billing/orders-to-bill",
      },
      {
        name: "Factures",
        route: "/billing/invoices",
      },
      {
        name: "Encours",
        route: "/billing/encours",
      },
      {
        name: "Rapprochement bancaire",
        route: "/billing/rapprochement",
      },
      {
        name: "Partenaires",
        route: "/billing/partner",
      },
    ],
  },
  // Séparation visuelle 1
  {
    name: "separator-1",
    separator: true,
  },
  {
    name: "Livreurs",
    route: "/",
    icon: IconLivreur,
    subcategories: [
      {
        name: "Planning",
        route: "/livreurs/planning",
      },
      {
        name: "Zones",
        route: "/livreurs/zones",
      },
      {
        name: "Performance",
        route: "/livreurs/performance",
      },
      {
        name: "Timeline dispatch",
        route: "/livreurs/timeline",
      },
      {
        name: "Motifs de problème",
        route: "/livreurs/motifs-probleme",
      },
    ],
  },
  {
    name: "Utilisateurs",
    route: "/",
    icon: IconUser,
    subcategories: [
      { name: "Liste", route: "/users" },
      { name: "Activité entreprises", route: "/clients/activite" },
    ],
  },
  {
    name: "Codes promo",
    route: "/",
    icon: IconPromoCode,
    subcategories: [
      { name: "Gestion", route: "/CodePromo" },
      { name: "Infos", route: "/CodePromo/stats" },
    ],
  },
  {
    name: "Tarifs transport",
    route: "/tarifs-transport",
    icon: IconCommand,
  },
  {
    name: "Digest ROI",
    route: "/parametres-digest-roi",
    icon: IconInfo,
  },
  {
    // Nos charges fixes, pour la barre « charges couvertes » du dashboard.
    // Voisine de « Digest ROI » dans le menu, mais sans rapport : celui-ci
    // chiffre le coût hypothétique du client, pas le nôtre.
    name: "Charges mensuelles",
    route: "/charges-mensuelles",
    icon: IconFacturation,
  },
  {
    name: "Récaps clients",
    route: "/recaps-clients",
    icon: IconInfo,
  },
  {
    name: "Jours fériés",
    route: "/jours-feries",
    icon: IconFacturation,
  },
  {
    name: "Livraisons",
    route: "/",
    icon: IconDelivery,
    subcategories: [
      {
        name: "Centres de livraison",
        route: "/deliveries",
      },
      {
        name: "Tours de livraison",
        route: "/tour",
      },
    ],
  },
  {
    name: "Instagram",
    route: "/instagram",
    icon: IconFounisseur,
  },
  {
    name: "Télémétrie",
    route: "/",
    icon: IconInfo,
    subcategories: [
      {
        name: "Couverture GPS",
        route: "/telemetry/gps-couverture",
      },
      {
        name: "Uploads",
        route: "/telemetry/uploads",
      },
      {
        name: "Devis abandonnés",
        route: "/telemetry/form-abandonments",
      },
    ],
  },
  // Séparation visuelle 2
  {
    name: "separator-2",
    separator: true,
  },
  {
    name: "RGPD/Sécurité",
    route: "/",
    icon: IconSecurity,
    subcategories: [
      {
        name: "Modifications",
        route: "/actions",
      },
      {
        name: "Consultations",
        route: "/consultations",
      },
      {
        name: "Connexions",
        route: "/login-attempts",
      },
      {
        name: "Suppressions",
        route: "/account-deletion-requests",
      },
      {
        name: "Comptes bloqués",
        route: "/locked-accounts",
      },
      {
        name: "Inscriptions à vérifier",
        route: "/inscriptions-a-verifier",
      },
    ],
  },
];

export default SidebarItems;
